import React, { useContext } from "react";
import { Button, Tooltip } from "antd";
import SectionPicker from "../SectionPicker";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { BiUndo } from "react-icons/bi";
import { CourseContext } from "../../../../Store";
import { courseDetailUrlNoWeekId } from "../../../../../../service/url";
import { HaveWeekTime } from "../../../../../../service/course";
import useCurrentDate from "utils/useCurrentDate";
import { EventBus } from "utils/eventBus";
import { RES_EVENT_PARAMS } from "../../../../../../service/CourseDetail/resource";
import { useUnmount } from "react-use";

export default function CourseHeader() {
    const history = useHistory();
    const { course } = useContext(CourseContext);
    const { batchNo } = useCurrentDate();
    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }
    const onStuView = () => {
        //target： src/pages/CourseDetail/Resource/index.tsx
        EventBus.emit(RES_EVENT_PARAMS.STUDENT_PERSPECTIVE_PREVIEW_OPEN);
    };

    useUnmount(() => {
        EventBus.removeAllListeners(
            RES_EVENT_PARAMS.STUDENT_PERSPECTIVE_PREVIEW_OPEN
        );
    });

    return (
        <div className={style.root}>
            <div>
                <h1 className={style.title}>
                    <Tooltip title={course.courseName} placement="bottom">
                        <span>{course.courseName}</span>
                    </Tooltip>

                    <Button
                        className={style.back}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </h1>

                {course.weekTimeId !== HaveWeekTime.no && <SectionPicker />}
                {course.weekTimeId === HaveWeekTime.no && (
                    <span className={style.infos}>
                        无学习计划或学习计划尚未同步到白果云
                    </span>
                )}
            </div>

            <div className={style.icons}>
                <Button
                    className={style.btn}
                    type="link"
                    href={`/course/${batchNo}/${course.courseNo}/${course.courseSeq}/score?from=detail`}>
                    <img
                        src={require("./img/icon4.png")}
                        alt=""
                        title="成绩管理"
                    />
                    <p>成绩管理</p>
                </Button>
                {isMatch("/resource") && (
                    <Button
                        type="link"
                        className={style.btn}
                        onClick={onStuView}>
                        <img
                            src={require("./img/icon1.png")}
                            alt=""
                            title="学生视角查看"
                        />
                        <p>学生视角查看</p>
                    </Button>
                )}
                <Button
                    className={style.btn}
                    type="link"
                    href={courseDetailUrlNoWeekId(course, "/courseChapters")}>
                    <img
                        src={require("./img/icon2.png")}
                        alt=""
                        title="课程章节"
                    />
                    <p>课程章节</p>
                </Button>
                {course.weekTimeId !== HaveWeekTime.no && (
                    <Button
                        className={style.btn}
                        type="link"
                        onClick={() =>
                            history.push(
                                `/course/${course.courseNo}/${course.courseSeq}/analyse/1`
                            )
                        }>
                        <img
                            src={require("./img/icon3.png")}
                            alt="课程分析"
                            title="课程分析"
                        />
                        <p>课程分析</p>
                    </Button>
                )}
            </div>
        </div>
    );
}
